import React from 'react'
import SelectField from 'material-ui/SelectField'
import MenuItem from 'material-ui/MenuItem'
import api from '../../api'

const styles = {
  container: {
    width: '100%'
  },
  country: {
    width: 'calc(50% - 10px)',
    marginRight: '10px',
    display: 'inline-block'
  },
  state: {
    width: 'calc(50% - 10px)',
    display: 'inline-block'
  }
}

class CountryState extends React.Component<any, any> {
  constructor () {
    super()
    this.state = {
      countries: [],
      states: []
    }
  }

  getCountryIndex (countries, countryValue) {
    if (countries) {
      for (let i = 0; i < countries.length; i++) {
        if (countries[i].country_abbr === countryValue) {
          return i
        }
      }
    }
    return 0
  }

  componentWillMount () {
    this.fetchCountriesAndStates()
  }

  componentWillReceiveProps (nextProps) {
    if (this.state.countries.length > 0) {
      let newStates = []
      if (this.state.countries[this.getCountryIndex(this.state.countries, nextProps.countryValue)].country_states) {
        newStates = this.state.countries[this.getCountryIndex(this.state.countries, nextProps.countryValue)].country_states
      }
      this.setState({
        states: newStates
      })
    }
  }

  handleCountryChange = (e, country) => {
    let newStates = []
    if (this.state.countries[country].country_states) {
      newStates = this.state.countries[country].country_states
    }
    this.setState({
      states: newStates
    })
    this.props.onCountryChange(this.state.countries[country].country_abbr)
  }

  handleStateChange = (e, state) => {
    this.props.onStateChange(this.state.states[state].state_abbr)
  }

  render () {
    return (
      <div style={styles.container}>
        <SelectField
          style={styles.country}
          value={this.props.countryValue}
          floatingLabelText='Country'
          onChange={this.handleCountryChange}
          errorText={this.props.countryErrorText || null}
        >
          {this.state.countries.map(option => {
            return (
              <MenuItem key={option.country_abbr} value={option.country_abbr} primaryText={option.country_name} />
            )
          })}
        </SelectField>
        <SelectField
          style={styles.state}
          value={this.props.stateValue}
          floatingLabelText='State'
          onChange={this.handleStateChange}
          errorText={this.props.stateErrorText || null}
        >
          {this.state.states.map(option => {
            return (
              <MenuItem key={option.state_abbr} value={option.state_abbr} primaryText={option.state_name} />
            )
          })}
        </SelectField>
      </div>
    )
  }

  fetchCountriesAndStates () {
    return api.get('admin/country_states')
      .then(res => res.json())
      .then(data => {
        this.setState({
          countries: data,
          states: data[this.getCountryIndex(data, this.props.countryValue)].country_states || []
        })
      })
  }
}

// @ts-ignore
CountryState.propTypes = {
  onCountryChange: React.PropTypes.func.isRequired,
  onStateChange: React.PropTypes.func.isRequired,
  countryValue: React.PropTypes.string.isRequired,
  stateValue: React.PropTypes.string.isRequired,
  countryErrorText: React.PropTypes.string,
  stateErrorText: React.PropTypes.string
}

export default CountryState
